module.exports = __webpack_public_path__ + "img/duel_skybreak.d42721d7.png";